import { styled } from "@vitality-ds/system";
import BaseButtonStyles from "./styles/BaseButton.styles";
import BaseContainerStyles from "./styles/BaseContainer.styles";
import BaseInnerStyles from "./styles/BaseInner.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseContainer = styled("div", BaseContainerStyles);
export var BaseInner = styled("div", BaseInnerStyles);
export var BaseButton = styled("button", BaseButtonStyles);